import { Injectable, OnInit } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoadingController, ToastController, ToastOptions, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { LoginResponse, AuthResponseData } from 'src/app/models/general/auth-response-vm';
import { LoginVM3 } from 'src/app/models/account/login-vm';
import { map } from 'rxjs/operators';
// import { StorageService } from './storage.service';
import * as CryptoJS from 'crypto-jS';
import { interval, Subscription } from 'rxjs';
import { StorageService } from './storage.service';
import { NavController } from '@ionic/angular';
import { IdbService } from 'src/app/services/indexdb.service';

type rTokenConfig = { RefreshToken: string };
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private fcApiUrl: string;
  private fcApiUrlSSO: string;
  private forgotPassword: string;
  private subscriptionRefreshToken: Subscription;
  private refreshTimeout: any;
  private refreshPromise: Promise<boolean> | null = null;
  private sessionExpiredAlertActive: boolean = false; // 🛡️ Prevents stacked session-expired dialogs
  constructor(
    public toast_ctrl: ToastController,
    private http: HttpClient,
    private toast_controller: ToastController,
    private loading_ctrl: LoadingController,
    private idb_service: IdbService,
    private storageService: StorageService,
    private nav_controller: NavController,
    private alertController: AlertController
  ) {
    this.fcApiUrl = environment.fcApiUrl;
    // this.fcApiUrlSSO = environment.fcApiUrlSSO;
    // this.forgotPassword = environment.forgotPassword;
  }

  private httpOptionsAuthKeyBased = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      ClientKey: environment.clientKey,
      Authorization: environment.clientAuthKey
    })
  };

  getFcApiUrl(url: string | null): string {
    if (url == null) {
      return this.fcApiUrl;
    }
    return this.fcApiUrl + url;
  }

  getHttpOptionsByKey() {
    return this.httpOptionsAuthKeyBased;
  }

  getforgotPasswordUrl() {
    return this.forgotPassword;
  }

  async getHttpOptionsByToken() {
    let token = await this.idb_service.getTkn()
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ClientKey: environment.clientKey,
        Authorization: 'Bearer ' + token
      }),
    };
  }

  async getHttpOptionsByTokenF() {
    let token = await this.idb_service.getTkn()
    return {
      headers: new HttpHeaders({
        ClientKey: environment.clientKey,
        Authorization: 'Bearer ' + token   //window.localStorage.getItem('ACCESS_TOKEN'),
      }),
    };
  }

  async getHttpOptionsByTokenProgress() {
    let token = await this.idb_service.getTkn();
    return {
      reportProgress: true,
      headers: new HttpHeaders({
        ClientKey: environment.clientKey,
        Authorization: 'Bearer ' + token //window.localStorage.getItem('ACCESS_TOKEN'),
      })
    };
  }

  async loginWithToken(loginName: string, token: string): Promise<{ success: boolean }> {
    try {
      // Store token for subsequent API use
      localStorage.setItem('authToken', token);

      // Build API URL from environment.ts
      const apiUrl = `${environment.fcApiUrl}/fcapi/account/lgn-wtkn`;

      // Call backend SSO login endpoint with Authorization header
      const response = await this.http.post<LoginResponse>(apiUrl, { loginName }, {
        headers: {
          Authorization: `Bearer ${token}`,
          ClientKey: environment.clientKey
        }
      }).toPromise();

      await this.idb_service.setLoginTokenData(response.Data);

      return { success: true };
    } catch (err) {
      console.error('SSO Login failed', err);
      return { success: false };
    }
  }


  // getHttpOptionsByTokenForMasterDataApi() {
  //   return {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       // Authorization: 'basic TkIwMDE6NDZlNzY0Zm5oM3M4',
  //       Authorization: `basic ${btoa(environment.masterDataApiKey)}`
  //     })
  //   };
  // }

  // left intentionally
  // private async fundCoreApiSessionOut(error: any) {
  //   //
  //   const loginVM = this.readLoginCred();
  //   if (loginVM == null) {
  //     await this.warnToast('Session Expired. Please login.');
  //     await this.router.navigate(['login']);
  //   } else {
  //     await this.warnToast('Restoring Session...');
  //     // await this.warnToast('Session Expired. Restoring...');
  //     const loginResponse = await this.getLoginResponse(loginVM);
  //     if (loginResponse == null) {
  //       return;
  //     }
  //     this.login(loginResponse);

  //     const authData = JSON.parse(this.storageService.readAuthData()) ;
  //     switch (authData.LoginUserType) {
  //       case 2:
  //         this.router.navigate(['advisor-dashboard']);
  //         break;
  //       default:
  //         this.router.navigate(['investor-dashboard']);
  //         break;
  //   }

  //    // await this.router.navigate(['investor-dashboard']);
  //     // await this.router.navigate(['quick-access']);
  //   }
  // }

  showMessage(message: string) {
    alert(message);
  }

  handlePassThrowError(resp: HttpErrorResponse): any {
    // GJ: code is not complete yet.
    switch (resp.status) {
      case 401: // Unauthorized
        this.errorToast('401', true);
        break;
      default:
        this.errorToast(resp.status.toString(), true);
    }
  }

  // handleError(resp: HttpErrorResponse): any {    
  //   console.log(resp);
  //   switch (resp.status) {
  //     case 401: // Unauthorized
  //       if (resp.error != null) {
  //         if (resp.error.status_from == 'GWS') {
  //           // this.showMessage(resp.error.message);
  //           this.errorToast(resp.error.message, false);
  //           console.log(resp.error.message);
  //         } else {
  //           //todo: remove later
  //           this.errorToast(resp.error.message, false);
  //           console.log(resp.error.message);
  //         }
  //       } else {
  //         //todo: remove later
  //         this.errorToast(
  //           JSON.stringify(resp) + 'handle error not implemented',
  //           false
  //         );
  //       }
  //       break;
  //     case 406: // Unauthorized

  //       if (resp.error != null) {
  //         if (resp.error.status_from == 'GWS') {
  //           // this.showMessage(resp.error.message);
  //           this.errorToast(resp.error.error.Data, false);
  //           console.log(resp.error.error.Data);
  //         } else {
  //           //todo: remove later
  //           this.errorToast(resp.error.error.Data, false);
  //           console.log(resp.error.error.Data);
  //         }
  //       } else {
  //         //todo: remove later
  //         this.errorToast(
  //           JSON.stringify(resp) + 'handle error not implemented',
  //           false
  //         );
  //       }
  //       break;
  //       case 0:
  //         this.errorToast(
  //           'network issue &#9888;',
  //           false
  //         );
  //       break;
  //     default:
  //       //todo: remove later
  //       this.errorToast(
  //         JSON.stringify(resp) + 'handle error not implemented',
  //         false
  //       );
  //   }
  //   //
  //   // switch (error.status) {
  //   //   case 401: // Unauthorized
  //   //   case 403: // Forbidden
  //   //     this.fundCoreApiSessionOut(error);
  //   //     break;
  //   //   case 406: // Not Acceptable
  //   //     this.warnToast(error.error.Data);
  //   //     break;
  //   //   case 405: // Method Not Allowed
  //   //   case 501: // Not Implemented
  //   //     this.errorToast(error.error.Data);
  //   //     break;
  //   //   default:
  //   //     this.errorToast('Some error occurred.');
  //   //     break;
  //   // }

  //   // 1xx: Informational
  //   // 2xx: Success
  //   // 3xx: Redirection
  //   // 4xx: Client Error
  //   // 5xx: Server Error
  // }

  public getErrorMessage(resp: any): string {
    if (!resp) return 'Unknown communication failure';

    let error = resp.error || resp;

    // 🛡️ Step 1: Handle cases where the resp is a string or a wrapped Error object
    if (typeof error === 'object' && error.message && !error.Data) {
      error = error.message;
    }

    // 🛡️ Step 2: Recursive JSON Parsing (handles cases where error is "Error: {...}" or stringified JSON)
    let parsedCount = 0;
    while (typeof error === 'string' && parsedCount < 3) {
      // Clean up common "Error: " prefix if present in stringified catch blocks
      let cleanError = error.trim();
      if (cleanError.startsWith('Error:')) {
        cleanError = cleanError.replace('Error:', '').trim();
      }

      try {
        const parsed = JSON.parse(cleanError);
        if (parsed && typeof parsed === 'object') {
          error = parsed;
          parsedCount++;
        } else {
          break; // Parsed to a primitive, stop
        }
      } catch (e) {
        // Not a JSON string or "Error: [JSON]" string
        break;
      }
    }

    // 🛡️ Step 3: Deep Extraction of 'Data' or 'message'
    if (error.Data) return error.Data;
    if (error.error?.Data) return error.error.Data;
    if (error.error?.error?.Data) return error.error.error.Data;
    if (error.message) return error.message;
    if (error.statusText) return error.statusText;

    // Fallback: Final safety stringify
    try {
      if (typeof error === 'string') return error;
      return JSON.stringify(error);
    } catch (e) {
      return 'An unparseable error occurred';
    }
  }

  handleError(resp: HttpErrorResponse): any {
    // 🛡️ Prevent duplicate toasts for the same error object
    if ((resp as any)._handled) {
      return;
    }
    (resp as any)._handled = true;

    //console.log('API Error Response:', resp);
    switch (resp.status) {
      case 401: // Unauthorized
        this.showSessionExpiredAlert(this.getErrorMessage(resp) || 'Session Expired (401)');
        break;
      case 406: // Not Acceptable        
      case 500: // Server Error
        this.errorToast(this.getErrorMessage(resp), true);
        break;
      case 0:
        // We show a toast here because status 0 only reaches this point
        // if ALL exponential backoff retries have been completely exhausted.
        this.errorToast('Unable to connect to the server. Please check your internet connection.', true);
        break;
      default:
        this.errorToast(this.getErrorMessage(resp), true);
    }
    //
    // switch (error.status) {
    //   case 401: // Unauthorized
    //   case 403: // Forbidden
    //     this.fundCoreApiSessionOut(error);
    //     break;
    //   case 406: // Not Acceptable
    //     this.warnToast(error.error.Data);
    //     break;
    //   case 405: // Method Not Allowed
    //   case 501: // Not Implemented
    //     this.errorToast(error.error.Data);
    //     break;
    //   default:
    //     this.errorToast('Some error occurred.');
    //     break;
    // }    
  }

  // login(loginResponse: AuthResponseData): void {
  //   this.storageService.setLoginData(loginResponse);
  // }

  // async logout(clearLoginDataOnly: boolean) {
  //   if (clearLoginDataOnly === true) {
  //     this.storageService.clearLoginData();
  //   } else {
  //     // todo: poojan we need to add progress bar (into the called function) since we are awaiting for the logout request.
  //     const url = this.getFundCoreUrl('/fcapi/account/logout');
  //     const httpOptions = this.getHttpOptionsByToken();
  //     await this.http.post<any>(url, {}, httpOptions);
  //     this.storageService.clearLoginData();
  //     //this.router.navigate(['login']);
  //     this.router.navigate(['welcome']);
  //   }
  //   this.globalService.loadFreshInvestors = true;
  // }

  // public readLoginCred(): LoginVM {
  //   let obj: LoginVM = null;
  //   const jsonStr = this.storageService.readLoginCred();
  //   if (jsonStr && jsonStr.length > 0) {
  //     const jsonObj = JSON.parse(jsonStr);
  //     if (jsonObj != null) {
  //       obj = LoginVM.resolve(jsonObj.LoginName, jsonObj.Password, jsonObj.LoginUserType);
  //     }
  //   }
  //   return obj;
  // }

  // public async signout() {
  //   this.storageService.clearLoginData();
  //   this.storageService.clearLoginCred();
  //   await this.logoutFromServer();
  //   await this.router.navigate(['login']);
  // }

  // private async logoutFromServer() {
  //   const url = this.getWonAppiUrl('/fcapi/account/logout');
  //   const httpOptions = this.getHttpOptionsByToken();
  //   await this.http.post<any>(url, {}, httpOptions);
  // }

  // public async getLoginResponse(loginVM: LoginVM) {
  //   const url = this.getWonAppiUrl('/fcapi/account/login');
  //   const data = { LoginName: loginVM.LoginName, Password: loginVM.Password, LoginUserType: loginVM.LoginUserType };
  //   const httpOptions = this.getHttpOptionsByKey();

  //   try {
  //     const response = await this.http.post<any>(url, data, httpOptions).toPromise();
  //     if (response && response.Data) {
  //       return response.Data;
  //     }
  //   } catch (error) {
  //     this.storageService.clearLoginCred();
  //     this.handleError(error);
  //   }
  //   return null;
  // }

  async showToast(msg: string, showClose: boolean) {
    const toastOption: ToastOptions = {
      message: msg,
      position: 'top',
      animated: true,
      // color: 'dark',
      // cssClass:'center-toast-message',
      translucent: true,
      //showCloseButton: true,
    };
    if (showClose) {
      toastOption.buttons = [
        {
          side: 'end',
          icon: 'close-outline',
          // text: 'close',
          handler: () => {
          },
        },
      ];
    }
    //else {
    toastOption.duration = 3000;
    //}
    const toast = await this.toast_controller.create(toastOption);
    await toast.present();
  }

  async warnToast(msg: string, showClose: boolean) {
    const toastOption: ToastOptions = {
      message: msg,
      position: 'top',
      animated: true,
      // color: 'dark',
      cssClass: 'gws-toast-warn',
      translucent: true,
      //showCloseButton: true,
    };
    if (showClose) {
      toastOption.buttons = [
        {
          side: 'end',
          icon: 'close-outline',
          // text: 'close',
          handler: () => {
          },
        },
      ];
    }
    //else {
    toastOption.duration = 3000;
    //}
    const toast = await this.toast_controller.create(toastOption);
    await toast.present();
  }

  async errorToast(msg: string, showClose: boolean) {
    const toastOption: ToastOptions = {
      message: msg,
      position: 'top',
      animated: true,
      // color: 'dark',
      cssClass: 'gws-toast-error',
      translucent: true,
      //showCloseButton: true,
    };
    if (showClose) {
      toastOption.buttons = [
        {
          side: 'end',
          icon: 'close-outline',
          // text: 'close',
          handler: () => {
          },
        },
      ];
    }
    // else {
    toastOption.duration = 10000;
    //}
    const toast = await this.toast_controller.create(toastOption);
    await toast.present();
  }

  async successToast(msg: string, showClose: boolean) {
    const toastOption: ToastOptions = {
      message: msg,
      position: 'top',
      animated: true,
      // color: 'dark',
      cssClass: 'gws-toast-success',
      translucent: true,
      //showCloseButton: true,
    };
    if (showClose) {
      toastOption.buttons = [
        {
          side: 'end',
          icon: 'close-outline',
          // text: 'close',
          handler: () => {
          },
        },
      ];
    }
    //else {
    toastOption.duration = 3000;
    //}
    const toast = await this.toast_controller.create(toastOption);
    await toast.present();
  }

  async infoToast(msg: string, showClose: boolean) {
    const toastOption: ToastOptions = {
      message: msg,
      position: 'top',
      animated: true,
      // color: 'dark',
      cssClass: 'gws-toast-info',
      translucent: true,
      //showCloseButton: true,
    };
    if (showClose) {
      toastOption.buttons = [
        {
          side: 'end',
          icon: 'close-outline',
          // text: 'close',
          handler: () => {
          },
        },
      ];
    }
    else {
      toastOption.duration = 3000;
    }
    const toast = await this.toast_controller.create(toastOption);
    await toast.present();
  }

  async showSessionExpiredAlert(msg: string) {
    // 🛡️ Singleton guard: only one session-expired alert can be active at a time.
    // Without this, every parallel 401 (home fires 5+ API calls at once) creates its own alert.
    if (this.sessionExpiredAlertActive) {
      console.warn('Session expired alert already active. Skipping duplicate.');
      return;
    }
    this.sessionExpiredAlertActive = true;

    const alert = await this.alertController.create({
      header: 'Session Expired',
      message: msg,
      cssClass: 'session-expired-alert',
      backdropDismiss: false,
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.sessionExpiredAlertActive = false; // 🔓 Reset when user dismisses
            this.nav_controller.navigateRoot('login-via-otp');
          }
        }
      ]
    });

    await alert.present();
  }

  async comingSoon() {
    this.warnToast('Coming Soon', false);
  }

  // async showToast(
  //   type?: 'error' | 'warn' | 'success' | 'info',
  //   position?: 'top' | 'middle' | 'bottom',
  //   showClose?: boolean,
  //   message?:string
  // ) {
  //   const toastOption: ToastOptions = {
  //     message: message ? message : 'Write any text here to be shown !',
  //     cssClass: null,
  //     duration: 1000,
  //     position: position ? position : 'top',
  //     buttons: [],
  //     // side: 'end',
  //     // icon: 'close-outline',
  //   };

  //   toastOption.cssClass = type?'gws-toast-' + type:'';

  //   if(showClose){
  //     toastOption.buttons = [
  //       {
  //         side: 'end',
  //         icon: 'close-outline',
  //         // text: 'close',
  //         handler: () => {
  //         },
  //       },
  //     ];
  //   }

  //   const toast = await this.toastController.create(toastOption);
  //   await toast.present();
  // }

  public postSN(url: string, data: any, options?: any, observeFullResponse = false): Promise<any> {
    if (observeFullResponse) {
      return this.http.post(url, data, { ...options, observe: 'response' }).toPromise();
    }
    return this.http.post(url, data, options).toPromise();
  }


  async validateTokenPreRequest(): Promise<boolean> {
    const lastRefresh = await this.idb_service.getLastRefreshedTime();
    if (lastRefresh === 0) return false;

    const now = Date.now();
    const eighteenMinsInMs = 18 * 60 * 1000;
    const isExpired = (now - lastRefresh) >= eighteenMinsInMs;

    return !isExpired;
  }

  async post(url: string, data: any, httpOptions: any): Promise<any> {
    const isAuthUrl = url.includes('/refresh-token') ||
                      url.includes('/login') ||
                      url.includes('/lgn-wtkn') ||
                      url.includes('/forget-password') ||
                      url.includes('/validate-mobile-otp-for-login') ||
                      url.includes('/validate-user-details-for-mobile-otp');

    if (!isAuthUrl) {
      const isTokenValid = await this.validateTokenPreRequest();
      if (!isTokenValid) {
        // 🔄 Token is stale — try to refresh BEFORE making the request
        const refreshed = await this.refreshAccessTokenManually(true);
        if (refreshed) {
          // ✅ Refresh succeeded — update Authorization header with new token
          const newToken = await this.idb_service.getTkn();
          if (httpOptions) {
            if (httpOptions.headers instanceof HttpHeaders) {
              httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + newToken);
            } else if (httpOptions.headers) {
              httpOptions.headers = { ...httpOptions.headers, 'Authorization': 'Bearer ' + newToken };
            } else {
              httpOptions.headers = new HttpHeaders({ 'Content-Type': 'application/json', ClientKey: environment.clientKey, Authorization: 'Bearer ' + newToken });
            }
          } else {
            httpOptions = await this.getHttpOptionsByToken();
          }
        } else {
          // ❌ Refresh failed — check if there is ANY valid refresh token
          const retryToken = await this.idb_service.getRTkn();
          if (!retryToken?.RefreshToken) {
            // No refresh token at all — session is definitively expired.
            // Abort the API call NOW. Do not hit the server with a doomed request.
            const sessionError: any = { status: 401, error: { Data: 'Your session has expired. Please login again.' }, _preRequestAbort: true };
            this.handleError(sessionError);
            throw sessionError;
          }
          // Has a refresh token but network failed — proceed anyway (network may recover)
        }
      }
    }

    try {
      return await this.http.post<any>(url, data, httpOptions).toPromise();
    } catch (error: any) {
      if (error._preRequestAbort) throw error; // Already handled above, don't double-handle

      const isRetry = httpOptions && httpOptions._retried;
      const isUnauthorized = error?.status === 401;
      const isNetworkError = error?.status === 0;

      if (isUnauthorized && !isAuthUrl && !isRetry) {
        const newHttpOptions = { ...httpOptions, _retried: true };
        const refreshed = await this.refreshAccessTokenManually(true);
        if (refreshed) {
          const newToken = await this.idb_service.getTkn();
          if (newHttpOptions.headers instanceof HttpHeaders) {
            newHttpOptions.headers = newHttpOptions.headers.set('Authorization', 'Bearer ' + newToken);
          } else if (newHttpOptions.headers) {
            newHttpOptions.headers = { ...newHttpOptions.headers, 'Authorization': 'Bearer ' + newToken };
          } else {
            newHttpOptions.headers = new HttpHeaders({ 'Content-Type': 'application/json', ClientKey: environment.clientKey, Authorization: 'Bearer ' + newToken });
          }
          return await this.http.post<any>(url, data, newHttpOptions).toPromise();
        } else {
          // Refresh failed after a real 401
          const retryToken = await this.idb_service.getRTkn();
          if (retryToken?.RefreshToken) {
            // Has a refresh token but network failed — preserve session, let component handle UI
            console.warn('API POST: Refresh failed due to network issue. Preserving session.');
            throw error;
          }
          // No refresh token — session truly expired, handleError will show the alert
        }
      } else if (isNetworkError && !isAuthUrl) {
        // 📶 Network transition retry loop (exponential backoff)
        let retries = 5;
        let delayMs = 2000;
        let lastError = error;
        while (retries > 0) {
          try {
            await new Promise(resolve => setTimeout(resolve, delayMs));
            if (!navigator.onLine) {
              console.warn('📶 API POST: Device offline. Waiting up to 8s for reconnect...');
              await new Promise<void>(resolve => {
                const timeout = setTimeout(resolve, 8000);
                window.addEventListener('online', () => { clearTimeout(timeout); resolve(); }, { once: true });
              });
            }
            const newHttpOptions = { ...httpOptions, _retried: true };
            return await this.http.post<any>(url, data, newHttpOptions).toPromise();
          } catch (retryErr: any) {
            lastError = retryErr;
            if (retryErr?.status === 0) {
              retries--;
              delayMs *= 1.5;
              console.warn(`📶 API POST: Network transitioning. Retrying in ${delayMs}ms... (${retries} left)`);
            } else {
              break;
            }
          }
        }
        error = lastError;
      }

      if (!isAuthUrl) {
        this.handleError(error);
      }
      throw error;
    }
  }

  async get(url: string, httpOptions: any): Promise<any> {
    const isAuthUrl = url.includes('/refresh-token') ||
                      url.includes('/login') ||
                      url.includes('/lgn-wtkn') ||
                      url.includes('/forget-password') ||
                      url.includes('/validate-mobile-otp-for-login') ||
                      url.includes('/validate-user-details-for-mobile-otp');

    if (!isAuthUrl) {
      const isTokenValid = await this.validateTokenPreRequest();
      if (!isTokenValid) {
        // 🔄 Token is stale — try to refresh BEFORE making the request
        const refreshed = await this.refreshAccessTokenManually(true);
        if (refreshed) {
          // ✅ Refresh succeeded — update Authorization header with new token
          const newToken = await this.idb_service.getTkn();
          if (httpOptions) {
            if (httpOptions.headers instanceof HttpHeaders) {
              httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + newToken);
            } else if (httpOptions.headers) {
              httpOptions.headers = { ...httpOptions.headers, 'Authorization': 'Bearer ' + newToken };
            } else {
              httpOptions.headers = new HttpHeaders({ 'Content-Type': 'application/json', ClientKey: environment.clientKey, Authorization: 'Bearer ' + newToken });
            }
          } else {
            httpOptions = await this.getHttpOptionsByToken();
          }
        } else {
          // ❌ Refresh failed — check if there is ANY valid refresh token
          const retryToken = await this.idb_service.getRTkn();
          if (!retryToken?.RefreshToken) {
            // No refresh token at all — session is definitively expired.
            // Abort the API call NOW. Do not hit the server with a doomed request.
            const sessionError: any = { status: 401, error: { Data: 'Your session has expired. Please login again.' }, _preRequestAbort: true };
            this.handleError(sessionError);
            throw sessionError;
          }
          // Has a refresh token but network failed — proceed anyway (network may recover)
        }
      }
    }

    try {
      return await this.http.get<any>(url, httpOptions).toPromise();
    } catch (error: any) {
      if (error._preRequestAbort) throw error; // Already handled above, don't double-handle

      const isRetry = httpOptions && httpOptions._retried;
      const isUnauthorized = error?.status === 401;
      const isNetworkError = error?.status === 0;

      if (isUnauthorized && !isAuthUrl && !isRetry) {
        const newHttpOptions = { ...httpOptions, _retried: true };
        const refreshed = await this.refreshAccessTokenManually(true);
        if (refreshed) {
          const newToken = await this.idb_service.getTkn();
          if (newHttpOptions.headers instanceof HttpHeaders) {
            newHttpOptions.headers = newHttpOptions.headers.set('Authorization', 'Bearer ' + newToken);
          } else if (newHttpOptions.headers) {
            newHttpOptions.headers = { ...newHttpOptions.headers, 'Authorization': 'Bearer ' + newToken };
          } else {
            newHttpOptions.headers = new HttpHeaders({ 'Content-Type': 'application/json', ClientKey: environment.clientKey, Authorization: 'Bearer ' + newToken });
          }
          return await this.http.get<any>(url, newHttpOptions).toPromise();
        } else {
          // Refresh failed after a real 401
          const retryToken = await this.idb_service.getRTkn();
          if (retryToken?.RefreshToken) {
            // Has a refresh token but network failed — preserve session, let component handle UI
            console.warn('API GET: Refresh failed due to network issue. Preserving session.');
            throw error;
          }
          // No refresh token — session truly expired, handleError will show the alert
        }
      } else if (isNetworkError && !isAuthUrl) {
        // 📶 Network transition retry loop (exponential backoff)
        let retries = 5;
        let delayMs = 2000;
        let lastError = error;
        while (retries > 0) {
          try {
            await new Promise(resolve => setTimeout(resolve, delayMs));
            if (!navigator.onLine) {
              console.warn('📶 API GET: Device offline. Waiting up to 8s for reconnect...');
              await new Promise<void>(resolve => {
                const timeout = setTimeout(resolve, 8000);
                window.addEventListener('online', () => { clearTimeout(timeout); resolve(); }, { once: true });
              });
            }
            const newHttpOptions = { ...httpOptions, _retried: true };
            return await this.http.get<any>(url, newHttpOptions).toPromise();
          } catch (retryErr: any) {
            lastError = retryErr;
            if (retryErr?.status === 0) {
              retries--;
              delayMs *= 1.5;
              console.warn(`📶 API GET: Network transitioning. Retrying in ${delayMs}ms... (${retries} left)`);
            } else {
              break;
            }
          }
        }
        error = lastError;
      }

      if (!isAuthUrl) {
        this.handleError(error);
      }
      throw error;
    }
  }

  postPipe(url: string, data: any, httpOptions: {}) {
    return this.http.post<any>(url, data, httpOptions).pipe(map(results => results));
  }

  loading: HTMLIonLoadingElement;
  async block(message?: string) {
    this.loading = await this.loading_ctrl.create({
      spinner: 'lines-small',
      message: message,
      cssClass: 'gws-custom-loading',
      showBackdrop: true,
      animated: true,
      backdropDismiss: false,
      keyboardClose: true,
    });
    this.loading.present();
  }

  async unblock() {
    if (this.loading) {
      this.loading.dismiss();
    }

  }

  returndata(l, p) {
    let result = '';
    let e = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 16; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    e = result;
    return { b: (CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify({ l: l, p: p })), CryptoJS.enc.Utf8.parse(e), { keySize: 16, iv: CryptoJS.enc.Utf8.parse(e), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString()), a: e };
  }

  async dataRefreshTokenFn() {
    this.logoutRefresh(); // 🔄 Reset any existing timer/interval first

    //console.log('🔄 Heartbeat: Starting background active refresh sync...');
    const dataRefreshToken: rTokenConfig = await this.idb_service.getRTkn();
    if (!dataRefreshToken || !dataRefreshToken.RefreshToken) {
      console.log('🔄 Heartbeat: No refresh token found. active heartbeat not started.');
      return;
    }

    // 🛡️ Proactive instant check on startup / foreground resume
    await this.performHeartbeatCheck();

    // 🕊️ ACTIVE SYNC: Execute heartbeat check every 30 seconds.
    // This completely prevents OS timer throttling/sleeping from freezing our countdowns on mobile devices!
    this.refreshTimeout = setInterval(async () => {
      await this.performHeartbeatCheck();
    }, 30000);
  }

  private async performHeartbeatCheck() {
    try {
      const dataRefreshToken: rTokenConfig = await this.idb_service.getRTkn();
      if (!dataRefreshToken || !dataRefreshToken.RefreshToken) return;

      const lastRefreshed = await this.idb_service.getLastRefreshedTime();
      if (lastRefreshed === 0) return;

      const now = Date.now();
      const refreshIntervalMin = 18; // 🛡️ 18 minutes overlap guard
      const refreshIntervalMs = refreshIntervalMin * 60 * 1000;

      if ((now - lastRefreshed) >= refreshIntervalMs) {
        //console.log('🔄 Heartbeat: Token has reached the 18-minute stale threshold. Refreshing silently...');
        await this.refreshAccessToken(true);
      }
    } catch (error) {
      console.error('🔄 Heartbeat: Error inside performHeartbeatCheck:', error);
    }
  }

  async refreshAccessToken(isSilent: boolean = false): Promise<boolean> {
    if (this.refreshPromise) {
      // 🛡️ Single-Flight: A refresh is already in progress. Join the existing promise.
      return this.refreshPromise;
    }

    this.refreshPromise = (async () => {
      try {
        const dataRefreshToken: rTokenConfig = await this.idb_service.getRTkn();
        if (!dataRefreshToken?.RefreshToken) {
          console.warn('🔄 Refresh Timer: No Refresh Token found in store. Stopping timer.');
          this.logoutRefresh(); // 🔒 user logged out, stop all timers
          return false; 
        }

        const tokenResponse = await this.getRefreshTokenResponse(dataRefreshToken.RefreshToken, isSilent);
        if (tokenResponse) {
          await this.idb_service.refreshLoginTokenData(tokenResponse);
          await this.idb_service.saveLastRefreshedTime(Date.now()); // ✅ Save success time
          return true;
        } else {
          console.error('🔄 Refresh Timer: API returned no data.');
          return false;
        }
      } catch (err) {
        console.error('🔄 Refresh Timer: Failed inside refreshAccessToken:', err);
        return false;
      } finally {
        this.refreshPromise = null; // Clear lock upon completion
      }
    })();

    return this.refreshPromise;
  }

  public async getRefreshTokenResponse(rToken: string, isSilentFallback: boolean = false) {
    const url = this.getFcApiUrl('/fcapi/account/refresh-token');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': environment.clientAuthKey,
        'ClientKey': environment.clientKey,
        'rftkn': 'Bearer ' + rToken
      })
    };

    // 📶 5 retries with exponential backoff + navigator.onLine check
    // NOTE: We use this.http.post directly (not this.post) because this.post skips
    // retries for auth URLs. All network resilience is handled here instead.
    let retries = 5;
    let delayMs = 2000;

    while (retries > 0) {
      try {
        const response = await this.http.post<any>(url, {}, httpOptions).toPromise();
        if (response && response.Data) {
          return response.Data;
        }
        break; // Empty/unexpected response — stop and return null
      } catch (error: any) {
        const isNetworkError = error.status === 0 || error.status >= 500;

        if (isNetworkError && retries > 1) {
          retries--;

          // ⏳ Wait base delay before retry
          await new Promise(resolve => setTimeout(resolve, delayMs));

          // 📡 If device still reports offline, wait up to 15s for cellular radio to connect
          if (!navigator.onLine) {
            console.warn('📶 Refresh Token: Device offline. Waiting up to 15s for reconnect...');
            await new Promise<void>(resolve => {
              const timeout = setTimeout(resolve, 15000);
              window.addEventListener('online', () => { clearTimeout(timeout); resolve(); }, { once: true });
            });
          }

          delayMs *= 1.5; // Exponential backoff: 2s → 3s → 4.5s → 6.75s → 10.1s
          console.warn(`🔄 Refresh Token: Network issue. Retrying... (${retries} left)`);
          continue;
        }

        console.error('🔄 Refresh Timer: API Call Failed:', error);

        // Only stop timer and log out for terminal auth errors (401/403/406)
        const isTerminalAuthError = error.status === 401 || error.status === 403 || error.status === 406;
        if (isTerminalAuthError) {
          console.warn('🔄 Refresh Timer: Terminal auth error. Stopping timer and clearing credentials.');
          await this.logoutCredData();
          this.showSessionExpiredAlert('Your session has expired due to security reasons. Please login again to continue.');
        } else {
          console.log('🔄 Refresh Timer: Non-terminal or network issue. Keeping session active.');
        }
        throw error;
      }
    }
    return null;
  }

  logoutRefresh() {
    //console.log('🔄 Refresh Timer: Cleaning up existing timers...');
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
      clearInterval(this.refreshTimeout); // 🛡️ Clean up both setTimeout and setInterval to be 100% safe
      this.refreshTimeout = null;
      //console.log('🔄 Refresh Timer: Pending setTimeout/setInterval cleared.');
    }
    if (this.subscriptionRefreshToken) {
      this.subscriptionRefreshToken.unsubscribe();
      this.subscriptionRefreshToken = null;
     // console.log('🔄 Refresh Timer: Active interval subscription cleared.');
    }
  }

  async logoutCredData() {
    this.logoutRefresh();
    await this.idb_service.delete('ACCESS_TOKEN_STORE', "ACCESS_TOKEN");
    await this.idb_service.delete('REFRESH_TOKEN_STORE', "REFRESH_TOKEN");
    await this.idb_service.saveLastRefreshedTime(0);
  }

  public async getFcAppPageUrl(routeKey: string, routeParam: any): Promise<string> {
    const token = await this.idb_service.getTkn();
    const data = {
      ck: environment.clientKey,
      tkn: token,
      rk: routeKey,
      rp: routeParam
    };
    const url = this.fcApiUrl + '/#!/lgnwt/' + btoa(JSON.stringify(data));
    return url;
  }

  public async getFcAppPageUrlSSOC(routeKey: string, routeParam: any): Promise<string> {
    const token = await this.idb_service.getTkn();
    const data = {
      ck: environment.clientKey,
      tkn: token,
      rk: routeKey,
      rp: routeParam
    };
    const url = this.fcApiUrlSSO + '/#!/lgnwt/' + btoa(JSON.stringify(data));
    return url;
  }

  async refreshAccessTokenManually(isSilent: boolean = false): Promise<boolean> {
    const dataRefreshToken: rTokenConfig = await this.idb_service.getRTkn();
    if (!dataRefreshToken?.RefreshToken) {
      return false;
    }

    const success = await this.refreshAccessToken(isSilent);
    if (success) {
      this.dataRefreshTokenFn(); // 🔄 Reschedule/Start the 18-minute background timer!
    }
    return success;
  }

}

